module.exports = function ClientSubscribeRequest(sessionID, selector) {
    this.sessionID = sessionID;
    this.selector = selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-subscribe-request.js
// module id = 299
// module chunks = 1